const state = {
    statuses: [],
};

const mutations = {
    setStatuses(st, payload) {
        st.statuses = payload;
    }
};

const actions = {
    setStatuses({ commit },  payload) {
        commit('setStatuses', payload);
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
};